import React, {useEffect, useState} from 'react';

type Props = {
    timeout: string;
    callback?: () => void;
}

const LocalStorageTimer = ({timeout, callback}: Props) => {
    const [timeDisplay, setTimeDisplay] = useState<string | null>('123.56');

    useEffect(() => {
        let timer: ReturnType<typeof setTimeout> | null = null;

        const checkForCleanup = () => {
            const timeDiff = (new Date(timeout)).getTime() - (new Date()).getTime();

            if (timeDiff > 0) {
                setTimeDisplay(new Date(timeDiff).toISOString().slice(15, 19));

                timer = setTimeout(() => {
                    checkForCleanup();
                }, 900)
            } else {
                if (callback) {
                    callback();
                }
            }
        }

        if (timeout) {
            const timeDiff = (new Date(timeout)).getTime() - (new Date()).getTime();

            if (timeDiff > 0) {
                checkForCleanup();
            }
        }

        return () => {
            if (timer) {
                clearTimeout(timer);
            } 
        }
    }, [callback, timeout]);

    return (
        <span>{timeDisplay}</span>
    );
}

export default LocalStorageTimer;